// extracted by mini-css-extract-plugin
export var content = "_n3-1";
export var fullScreen = "_n3-0";